import React from 'react';

function ListingDetailContent({ listing }) {
  return (
    <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
      {/* Main content */}
      <div className="sm:col-span-4 space-y-6">
        {/* Description */}
        <div>
          <h2 className="text-lg font-medium text-gray-900">Description</h2>
          <div className="mt-2 text-gray-600">
            <p>{listing?.description || 'No description provided.'}</p>
          </div>
        </div>

        {/* Quantity & Storage */}
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
          <div>
            <h2 className="text-lg font-medium text-gray-900">Quantity</h2>
            <div className="mt-2 text-gray-600 flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
              </svg>
              <span>{listing?.quantity} {listing?.unit || 'units'}</span>
            </div>
          </div>

          <div>
            <h2 className="text-lg font-medium text-gray-900">Storage Requirements</h2>
            <div className="mt-2 text-gray-600 flex items-center">
              {listing?.storageRequirements === 'refrigerated' && (
                <>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                  </svg>
                  <span>Refrigerated</span>
                </>
              )}
              {listing?.storageRequirements === 'frozen' && (
                <>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                  <span>Frozen</span>
                </>
              )}
              {(!listing?.storageRequirements || listing?.storageRequirements === 'room_temperature') && (
                <>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                  <span>Room Temperature</span>
                </>
              )}
            </div>
          </div>
        </div>
        
        {/* Allergens */}
        {listing?.allergens && (
          <div>
            <h2 className="text-lg font-medium text-gray-900">Allergens</h2>
            <div className="mt-2 text-gray-600 flex items-start">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1 text-red-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
              <span>{listing.allergens}</span>
            </div>
          </div>
        )}
        
        {/* Pickup Instructions */}
        {listing?.pickupInstructions && (
          <div>
            <h2 className="text-lg font-medium text-gray-900">Pickup Instructions</h2>
            <div className="mt-2 text-gray-600">
              <p>{listing.pickupInstructions}</p>
            </div>
          </div>
        )}
      </div>
      
      {/* Sidebar */}
      <div className="sm:col-span-2">
        <div className="bg-gray-50 rounded-lg px-4 py-5 sm:px-6">
          <h2 className="text-lg font-medium text-gray-900 mb-3">Location</h2>
          <div className="text-sm text-gray-600 mb-4">
            <div className="flex items-start">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1 text-gray-400 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span>{listing?.location?.address || 'Address not available'}</span>
            </div>
          </div>
          
          {/* Map placeholder - in a real app this would be an actual map */}
          <div className="h-32 bg-gray-200 rounded-md flex items-center justify-center">
            <span className="text-xs text-gray-500">Location map will appear here</span>
          </div>
          
          {/* Distance info if available */}
          {listing?.distance && (
            <div className="mt-3 text-sm">
              <span className="font-medium text-primary-600">{listing.distance.toFixed(1)} km</span> from your location
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ListingDetailContent;
